import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDevice } from './useDevice';
import shareIcon from './shareIcon.png';
import questionIcon from './question.png';

function HamburgerIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" aria-hidden="true">
      <rect x="2" y="4" width="18" height="2" rx="1" fill="#1a1a1a" />
      <rect x="2" y="10" width="18" height="2" rx="1" fill="#1a1a1a" />
      <rect x="2" y="16" width="18" height="2" rx="1" fill="#1a1a1a" />
    </svg>
  );
}

function CanvasNav({ isPublished, onPublish, onShare, onOpenHelp }) {
  const { isPhone } = useDevice();
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    if (!menuOpen) return undefined;
    const handlePointer = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handlePointer);
    document.addEventListener('touchstart', handlePointer);
    return () => {
      document.removeEventListener('mousedown', handlePointer);
      document.removeEventListener('touchstart', handlePointer);
    };
  }, [menuOpen]);

  const disabledButtonStyle = {
    ...publishButtonStyle,
    opacity: 0.5,
    cursor: 'not-allowed',
    pointerEvents: 'none',
  };

  const galleryDisabled = !isPublished;

  if (isPhone) {
    return (
      <nav className="navigation" style={phoneNavStyle}>
        <div ref={menuRef} style={hamburgerWrapperStyle}>
          <button
            type="button"
            onClick={() => setMenuOpen((o) => !o)}
            aria-label="Open menu"
            aria-expanded={menuOpen}
            style={hamburgerButtonStyle}
          >
            <HamburgerIcon />
          </button>
          {menuOpen && (
            <div style={menuPanelStyle} role="menu">
              <Link
                to="/"
                style={menuItemLinkStyle}
                onClick={() => setMenuOpen(false)}
                role="menuitem"
              >
                Canvas
              </Link>
              <button
                type="button"
                style={menuItemButtonStyle}
                onClick={() => {
                  setMenuOpen(false);
                  onOpenHelp();
                }}
                role="menuitem"
              >
                Help
              </button>
              <Link
                to="/blog"
                style={menuItemLinkStyle}
                onClick={() => setMenuOpen(false)}
                role="menuitem"
              >
                Blog
              </Link>
              <Link
                to={galleryDisabled ? '#' : '/Gallery'}
                style={
                  galleryDisabled
                    ? { ...menuItemLinkStyle, ...disabledLinkStyle }
                    : menuItemLinkStyle
                }
                onClick={() => !galleryDisabled && setMenuOpen(false)}
                role="menuitem"
              >
                Gallery
              </Link>
            </div>
          )}
        </div>
        <ul style={ulStyle}>
          <li style={galleryDisabled ? { ...liStyle, ...disabledLinkStyle } : liStyle}>
            <Link to={galleryDisabled ? '#' : '/Gallery'}>Gallery</Link>
          </li>
          <li style={liStyle}>
            <Link to="/my-doodles">My Doodles</Link>
          </li>
          <li style={liStyle} onClick={onShare}>
            <button style={buttonStyle}>
              <img src={shareIcon} alt="Share" style={iconStyle} />
            </button>
          </li>
          <li style={liStyle}>
            <button
              onClick={!isPublished ? onPublish : undefined}
              style={isPublished ? disabledButtonStyle : publishButtonStyle}
            >
              {isPublished ? 'Published' : 'Publish'}
            </button>
          </li>
        </ul>
      </nav>
    );
  }

  return (
    <nav className="navigation" style={navStyle}>
      <Link to="/" style={brandStyle}>
        the daily <span style={brandAccentStyle}>art</span>
      </Link>
      <ul style={ulStyle}>
        <li style={liStyle} onClick={onOpenHelp}>
          <img src={questionIcon} alt="?" style={questionStyle} />
        </li>
        <li style={galleryDisabled ? { ...liStyle, ...disabledLinkStyle } : liStyle}>
          <Link to={galleryDisabled ? '#' : '/Gallery'}>Gallery</Link>
        </li>
        <li style={liStyle}>
          <Link to="/my-doodles">My Doodles</Link>
        </li>
        <li style={liStyle} onClick={onShare}>
          <button style={buttonStyle}>
            <img src={shareIcon} alt="Share" style={iconStyle} />
          </button>
        </li>
        <li style={liStyle}>
          <button
            onClick={!isPublished ? onPublish : undefined}
            style={isPublished ? disabledButtonStyle : publishButtonStyle}
          >
            {isPublished ? 'Published' : 'Publish'}
          </button>
        </li>
      </ul>
    </nav>
  );
}

const navStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '0 16px',
  height: '30px',
  backgroundColor: '#f4f4f4',
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
};

const phoneNavStyle = {
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '30px',
  backgroundColor: '#f4f4f4',
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
  zIndex: 100,
};

const brandStyle = {
  fontSize: '18px',
  fontWeight: 700,
  color: '#1a1a1a',
  textDecoration: 'none',
  letterSpacing: '-0.01em',
  fontFamily:
    "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
};

const brandAccentStyle = {
  color: '#4CAF50',
};

const hamburgerWrapperStyle = {
  position: 'absolute',
  left: '12px',
  top: '50%',
  transform: 'translateY(-50%)',
};

const hamburgerButtonStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'none',
  border: 'none',
  padding: '4px',
  cursor: 'pointer',
};

const menuPanelStyle = {
  position: 'absolute',
  top: 'calc(100% + 6px)',
  left: 0,
  minWidth: '140px',
  backgroundColor: '#fff',
  border: '1px solid #eee',
  borderRadius: '8px',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.12)',
  display: 'flex',
  flexDirection: 'column',
  padding: '4px 0',
  zIndex: 9999,
};

const menuItemLinkStyle = {
  display: 'block',
  padding: '12px 16px',
  color: '#1a1a1a',
  textDecoration: 'none',
  fontSize: '15px',
};

const menuItemButtonStyle = {
  display: 'block',
  width: '100%',
  textAlign: 'left',
  padding: '12px 16px',
  color: '#1a1a1a',
  background: 'none',
  border: 'none',
  fontSize: '15px',
  fontFamily: 'inherit',
  cursor: 'pointer',
};

const ulStyle = {
  listStyleType: 'none',
  margin: '5px',
  padding: 0,
  display: 'flex',
};

const liStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '50px',
  marginRight: '10px',
};

const buttonStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '30px',
  background: 'none',
  border: 'none',
  padding: '0',
  cursor: 'pointer',
};

const disabledLinkStyle = {
  opacity: 0.5,
  pointerEvents: 'none',
};

const iconStyle = {
  width: '24px',
  height: 'auto',
};

const questionStyle = {
  width: '18px',
  height: 'auto',
};

const publishButtonStyle = {
  backgroundColor: '#4CAF50',
  color: 'white',
  padding: '5px',
  textAlign: 'center',
  textDecoration: 'none',
  display: 'inline-block',
  fontSize: '15px',
  margin: '5px',
  cursor: 'pointer',
  border: 'none',
  borderRadius: '4px',
};

export default CanvasNav;
